import React, { Component } from "react";
import { observer } from "mobx-react";
import { overlay } from "overlay-kit";

import { pay_free_yntype } from "http/SettingConn";
import { fn_dlvConnectCodeList } from "function/FnBodyDelivery";
import { fn_devliery_connect_add_pop } from "function/FnBodyDelivery";
import DlvNumModal from "./DlvNumModal";

@observer
class DlvConnectView extends Component {
  constructor(props) {
    super(props);
    this.inputFocus = React.createRef();
  }

  // 바로고 전화번호 저장 함수
  handleBgoPhoneNumber = phoneNumber => {
    const { rootStore } = this.props;
    const code = rootStore.deliveryStore.getDlvConnectCode;

    rootStore.settingStore.setDlvRegistInfo("storeTel", phoneNumber);

    fn_devliery_connect_add_pop(rootStore, code);
  };

  render() {
    const { rootStore } = this.props;
    const { layerStore } = rootStore;
    const connectBtnClass = rootStore.deliveryStore.getDlvConnectCode.length === 0 ? "off" : "";
    const code = rootStore.deliveryStore.getDlvConnectCode;
    let dlvList = rootStore.deliveryStore.getDeliveryConnectList;

    const handleConnect = () => {
      layerStore.setLayerDlvConnectPop(false);
      if (code.deliveryCode === "BGO") {
        overlay.open(({ isOpen, close }) => (
          <DlvNumModal
            open={isOpen}
            close={close}
            title={"배달대행사 추가"}
            text={"바로고 연동을 위해"}
            onConfirm={this.handleBgoPhoneNumber}
            rootStore={rootStore}
          />
        ));
      } else {
        fn_devliery_connect_add_pop(rootStore, code);
      }
    };

    return (
      <div className={"layer_comm layer_common_type " + (layerStore.getLayerDlvConnectPop ? " layer_open" : "")}>
        <div className="bg"></div>
        <div className="layer_content dlv">
          <div className="article_common_type dlv">
            <div className="section_tit_comm">
              <h1>
                <span className="ico"></span>배달대행사 연동하기
              </h1>
            </div>
            <div className="section_sub_tit">
              <h2>
                연동할 배달대행사를 선택하세요<span>(가나다순 정렬)</span>
              </h2>
            </div>
            <div className="scroll">
              <div className="inner">
                <ul className="section_dlv_list">
                  {Array.isArray(dlvList) && dlvList.length > 0
                    ? dlvList.map((item, idx) =>
                        item.mappingYn === "N" ? (
                          <li
                            key={idx}
                            className={code.subDeliveryCode === item.subDeliveryCode ? "on" : ""}
                            onClick={event => fn_dlvConnectCodeList(rootStore, item)}
                          >
                            <p>{item.deliveryServiceName}</p>
                            <p className="serviceNm">{item.parentDeliveryServiceName}</p>
                          </li>
                        ) : (
                          ""
                        )
                      )
                    : ""}
                </ul>
              </div>
            </div>
            <div className="btns">
              <button
                type="button"
                className="reset"
                onClick={event => {
                  rootStore.deliveryStore.setDlvConnectCode([]);
                  layerStore.setLayerDlvConnectPop(false);
                }}
              >
                취소
              </button>
              <button
                type="button"
                className={"search " + connectBtnClass}
                disabled={connectBtnClass === "off"}
                onClick={handleConnect}
              >
                연동하기
              </button>
            </div>
            <div className="btn_close btn_close_comm">
              <button
                onClick={event => {
                  rootStore.deliveryStore.setDlvConnectCode([]);
                  layerStore.setLayerDlvConnectPop(false);
                  pay_free_yntype(rootStore);
                }}
              >
                <span>닫기</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DlvConnectView;
